import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PressStatementArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-530.000000, -46.000000)"
      >
        <g transform="translate(530.000000, 46.000000)">
          <path
            d="M2.3306281e-16,15 C2.3306281e-16,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 2.3306281e-16,6.716 2.3306281e-16,15"
            fill="#008CC7"
          />
          <path
            d="M11.7954,16.0703 C9.9064,16.0703 8.7724,13.8023 8.7724,13.8023 C7.6384,12.2913 8.3944,10.7793 8.3944,10.7793 C8.3944,8.8893 8.7724,8.5113 8.7724,8.5113 C9.5284,7.0003 11.7954,7.0003 11.7954,7.0003 L11.5484,7.0003 C11.5484,7.0003 13.8164,7.0003 14.5724,8.5113 C14.5724,8.5113 14.9504,8.8893 14.9504,10.7793 C14.9504,10.7793 15.7064,12.2913 14.5724,13.8023 C14.5724,13.8023 13.4384,16.0703 11.5484,16.0703"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M13.7402,16.543 C13.8402,16.413 14.0182,16.376 14.1662,16.448 C14.8522,16.782 16.6332,17.66 16.9012,17.918 C17.1832,18.188 17.9412,19.37 18.1712,20.503 C18.2392,20.839 18.0152,21.167 17.6792,21.236 C16.6402,21.45 14.5192,21.856 12.2072,22.034 C11.7532,22.069 11.2982,22.064 10.8442,22.034 C9.2402,21.926 5.4762,21.62 5.2142,21.118 C4.8802,20.478 6.2162,17.918 6.8842,17.598 C7.4082,17.347 8.6542,16.799 9.1642,16.575 C9.2922,16.52 9.4432,16.541 9.5452,16.637 C9.8462,16.92 10.5682,17.492 11.5582,17.598 C12.6832,17.718 13.4332,16.941 13.7402,16.543"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M5.1616,20.916 C5.1616,20.916 5.1616,23 11.7496,23 C18.3376,23 18.1716,20.723 18.1716,20.723 L5.1616,20.916 Z"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M20.5932,7.3486 C18.2482,7.3486 16.3472,9.0226 16.3472,11.0876 C16.3472,12.1976 16.8972,13.1936 17.7692,13.8776 L17.7692,15.9996 L19.9912,14.7876 C20.1882,14.8126 20.3882,14.8266 20.5932,14.8266 C22.9372,14.8266 24.8382,13.1526 24.8382,11.0876 C24.8382,9.0226 22.9372,7.3486 20.5932,7.3486"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M18.5102,11.6934 C18.1582,11.6934 17.8732,11.4084 17.8732,11.0564 C17.8732,10.7054 18.1582,10.4204 18.5102,10.4204 C18.8622,10.4204 19.1472,10.7054 19.1472,11.0564 C19.1472,11.4084 18.8622,11.6934 18.5102,11.6934"
            fill="#008CC7"
          />
          <path
            d="M22.7558,11.6934 C22.4038,11.6934 22.1188,11.4084 22.1188,11.0564 C22.1188,10.7054 22.4038,10.4204 22.7558,10.4204 C23.1078,10.4204 23.3928,10.7054 23.3928,11.0564 C23.3928,11.4084 23.1078,11.6934 22.7558,11.6934"
            fill="#008CC7"
          />
          <path
            d="M20.6333,11.6934 C20.2813,11.6934 19.9963,11.4084 19.9963,11.0564 C19.9963,10.7054 20.2813,10.4204 20.6333,10.4204 C20.9853,10.4204 21.2703,10.7054 21.2703,11.0564 C21.2703,11.4084 20.9853,11.6934 20.6333,11.6934"
            fill="#008CC7"
          />
        </g>
      </g>
    </Icon>
  )
}
